import Vue from "vue";

/** @typedef {import("../types").FiltrosOcorrencia} FiltrosOcorrencia */
/** @typedef {import("../types").StateRelatoOcorrencia} StateRelatoOcorrencia */

/**
 * Mutações do módulo relatoOcorrencia.
 * Filtros, paginação e controle de loading da listagem.
 */

/**
 * Filtros padrão (sem o cooperado preservado). Usado ao limpar/resetar.
 */
const filtrosIniciais = {
  placa: null,
  status: null,
  projeto: null,
  tipoOcorrencia: null,
  dataOcorrenciaDe: null,
  dataOcorrenciaAte: null
};

export default {
  /**
   * Aplica os filtros combinando com os padrões e reseta a página.
   * @param {StateRelatoOcorrencia} state
   * @param {FiltrosOcorrencia} filtros
   */
  SET_FILTROS(state, filtros) {
    const proximo = { ...filtrosIniciais, ...(filtros || {}) };
    try {
      if (JSON.stringify(state.filtros) === JSON.stringify(proximo)) {
        state.filtros = proximo;
        return;
      }
    } catch (_e) {
      return;
    }
    state.filtros = proximo;
    state.paginaAtual = 1;
  },
  RESET_FILTROS(state) {
    state.filtros = { ...filtrosIniciais };
    state.paginaAtual = 1;
  },
  /**
   * Define a página atual (default 1).
   * @param {StateRelatoOcorrencia} state
   * @param {number} page
   */
  SET_PAGINA_ATUAL(state, page) {
    Vue.set(state, "paginaAtual", page || 1);
  },
  /**
   * Define a quantidade de itens por página (default 5).
   * @param {StateRelatoOcorrencia} state
   * @param {number} size
   */
  SET_ITENS_POR_PAGINA(state, size) {
    Vue.set(state, "itensPorPagina", size || 5);
  },
  SET_TOTAL_REGISTROS(state, total) {
    Vue.set(state, "totalRegistros", total || 0);
  },
  SET_LOADING(state, loading) {
    Vue.set(state, "loading", !!loading);
  },
  RESET_PAGINACAO(state) {
    state.paginaAtual = 1;
    state.itensPorPagina = 5;
    state.totalRegistros = 0;
  }
};
